import BasicRouterView from "../../../components/BasicRouterView.vue";

const transferenciaRoutes = {
  path: "transf",
  redirect: { name: "transferencia-listar" },
  meta: {
    label: "Transferência",
    icon: "sync_alt",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "transferencia/listar",
      name: "transferencia-listar",
      meta: {
        label: "Listar",
        icon: "list",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "transferencia" */ "./views/ListarTransferencias.vue"
        ),
    },
    {
      path: "transferencia/listar-mrp",
      name: "transferencia-listar-mrp",
      meta: {
        label: "Listar Mrp",
        icon: "list",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "transferencia" */ "./views/ListarTransferenciaMrp.vue"
        ),
    },
    {
      path: "transferencia/detalhe-transferencia/:transferenciaId",
      name: "transferencia-detalhe",
      meta: {
        label: "Detalhe",
        icon: "list",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "transferencia" */ "./views/DetalheTransferencia.vue"
        ),
    },
    {
      path: "transferencia/detalhe-transferencia-mrp/:transferenciaId",
      name: "transferencia-detalhe-mrp",
      meta: {
        label: "Detalhe",
        icon: "list",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "transferencia" */ "./views/DetalheTransferenciaMrp.vue"
        ),
    },
    {
      path: "transferencia/imprimir/:transferenciaId",
      name: "transferencia-imprimir",
      meta: {
        label: "Imprimir",
        icon: "list",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "transferencia" */ "./views/ImpressaoTransferencia.vue"
        ),
    },
  ],
};

export default transferenciaRoutes;
